import settings from '../../config/settings';
import axiosNonAuth from './axiosNonAuth';

const {apiBaseUrl} = settings;

export default class CampaignApi {
  static getCampaigns(campaignIds) {
    return Promise.all(campaignIds.map(CampaignApi.getCampaign));
  }

  static getCampaign(id) {
    return axiosNonAuth.get(`${apiBaseUrl}/campaigns/${id}/`);
  }

  static getByIframeKey(key) {
    return axiosNonAuth.get(`${apiBaseUrl}/campaigns/by-iframe-key/?key=${key}`);
  }

  static getCampaignWithCards(id) {
    return axiosNonAuth.get(`${apiBaseUrl}/campaigns/${id}/?expand=cards.card.program`);
  }

  static getCampaignsForCard(cardId) {
    return axiosNonAuth.get(`${apiBaseUrl}/campaigns/?card=${cardId}`);
  }

  static checkCampaignUserTargeting(campaignId) {
    return axiosNonAuth.post(`${apiBaseUrl}/campaigns/${campaignId}/check-targeting/`);
  }

  static checkGeoRedirect(campaignId, clientIp) {
    const data = {};
    if (clientIp) {
      data.ip = clientIp;
    }
    return axiosNonAuth.post(`${apiBaseUrl}/campaigns/${campaignId}/check-geo-redirect/`, data);
  }
}
